import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M3.00549 24.1493C3.08183 25.1841 3.94564 26 5 26H27L27.1493 25.9945C28.1841 25.9182 29 25.0544 29 24V7L28.9933 6.88338C28.9355 6.38604 28.5128 6 28 6H4L3.88338 6.00673C3.38604 6.06449 3 6.48716 3 7V24L3.00549 24.1493ZM5 20H10V24H5V20ZM27 20H12V24H27V20ZM5 14H10V18H5V14ZM27 14H12V18H27V14ZM5 8H27V12H5V8Z"
	})
});
export default SvgTable;
